import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=72b1383a&scoped=true&"
import script from "./ModuleHeader.vue?vue&type=script&lang=js&"
export * from "./ModuleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=72b1383a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1383a",
  null
  
)

component.options.__file = "ModuleHeader.vue"
export default component.exports